export const ScrollDirection = Object.freeze({
  Up: 'up',
  Down: 'down',
});
